module.exports = __webpack_public_path__ + "img/61.cba1b339.jpg";